const NODE_ENV = process.env.NODE_ENV

/**
 * TurnstileEnvValues
 * This class is used to manage the Turnstile environment variables.
 *
 * The values used for local development taken from this link:
 * https://developers.cloudflare.com/turnstile/troubleshooting/testing
 */
class TurnstileEnvValues {
  TURNSTILE_SITE_KEY: string
  TURNSTILE_SECRET_KEY: string
  private TURNSTILE_DEV_MODE: ReturnType<typeof TurnstileEnvValues.modes>[number] | null

  constructor() {
    this.TURNSTILE_DEV_MODE = this.getMode()
    this.TURNSTILE_SITE_KEY = this.getTurnstileSiteKey()
    this.TURNSTILE_SECRET_KEY = this.getTurnstileSecretKey()
  }

  public static modes() {
    return ['success', 'error'] as const
  }

  private getMode() {
    const mode = process.env.NEXT_PUBLIC_TURNSTILE_DEV_MODE

    if (!Array.from<string>(TurnstileEnvValues.modes()).includes(mode)) {
      console.info(
        `Invalid NEXT_PUBLIC_TURNSTILE_DEV_MODE value: ${mode}. Expected ${TurnstileEnvValues.modes().join(
          ' or ',
        )}.`,
      )
      return null
    }

    return mode as TurnstileEnvValues['TURNSTILE_DEV_MODE']
  }

  private getTurnstileSecretKey() {
    if (NODE_ENV === 'production' || !this.TURNSTILE_DEV_MODE) {
      //* Production value
      return process.env.TURNSTILE_SECRET_KEY
    }

    //* Local dev values
    if (this.TURNSTILE_DEV_MODE === 'error') {
      //* Error value
      return '2x0000000000000000000000000000000AA'
    }

    //* Success value
    return '1x0000000000000000000000000000000AA'
  }

  private getTurnstileSiteKey() {
    if (NODE_ENV === 'production' || !this.TURNSTILE_DEV_MODE) {
      //* Production value
      return '0x4AAAAAAACRwYjpnMIaYGPg'
    }

    //* Local dev values
    if (this.TURNSTILE_DEV_MODE === 'error') {
      //* Error value
      return '2x00000000000000000000AB'
    }

    //* Success value
    return '1x00000000000000000000AA'
  }
}

/**
 * One env config file to rule them all
 */
export const ENV_CONFIG = {
  ...new TurnstileEnvValues(),
  // * Shared values between staging and production
  TURNSTILE_SITEVERIFY_URL: 'https://challenges.cloudflare.com/turnstile/v0/siteverify',
  SENTRY_DSN:
    'https://b9090af4e3d444c3c4267070cbc38fec@o4508358359187456.ingest.de.sentry.io/4508806660948048',
  NODE_ENV,
  //* Client env variables
  DIRECTUS_URL: process.env.NEXT_PUBLIC_DIRECTUS_URL,
  RELEASE_ID: process.env.NEXT_PUBLIC_RELEASE_ID,
  WEB_URL: process.env.NEXT_PUBLIC_WEB_URL,
  INSTABOX_TRACKING_URL: process.env.NEXT_PUBLIC_INSTABOX_TRACKING_URL,
  INSTABEE_TRACKING_URL: process.env.NEXT_PUBLIC_INSTABEE_TRACKING_URL,
} as const
